<template>
  <v-dialog v-model="dialog" persistent max-width="950px" ref="winAssociation">
    <v-card>
      <v-card-title>
        <div>
          <h1>
            Importer
            <span class="bis">{{what}}</span>
          </h1>
        </div>
      </v-card-title>
      <v-card-text grid-list-xl :style="stylecontainer">
        <v-container fluid pa-0 grid-list-xl formlittle ref="mycontainer">
          <v-form ref="form" v-model="valid">
            <m-form-file
              :label="`Fichier Excel de ${what}`"
              ref="inputMatrice"
              @inputfile="hasFileMatrice"
            />
          </v-form>
          <v-btn
            depressed
            @click="showNormeMatrice=!showNormeMatrice"
            class="btn-norme-matrice"
          >Règles à respecter pour importer correctement {{what}}</v-btn>
          <v-expand-transition>
            <div class="mt-3" v-show="showNormeMatrice">
              <p>Le fichier excel à importer doit respecter certaines règles</p>
              <table class="tablestriped">
                <thead>
                  <tr>
                    <th>Colonne</th>
                    <th>Valeur</th>
                    <th>Remarque</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="norme in $store.state.norme_matrice" :key="norme.col">
                    <td>{{norme.col}}</td>
                    <td>{{norme.val}}</td>
                    <td>{{norme.remarque}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-expand-transition>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary2" text @click="cancelWin()" :disabled="disabledBtn">Annuler</v-btn>
        <v-btn color="primary2" depressed :disabled="disabledBtn" @click="saveWin()">Importer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "matricewinimport",
  props: ["filters", "what", "ca_id"],
  data() {
    return {
      stylecontainer: ``,
      disabledBtn: false,
      dialog: false,
      valid: true,
      matrice: null,
      showNormeMatrice: false
    };
  },
  mounted() {
    window.addEventListener("resize", this.setContainerStyle);
  },
  destroyed() {
    window.removeEventListener("resize", this.setContainerStyle);
  },
  computed: {},
  watch: {
    showNormeMatrice() {
      this.setContainerStyle(true);
    }
  },
  components: {},
  methods: {
    open() {
      this.dialog = true;
      this.disabledBtn = false;
      this.setContainerStyle();
      //if (this.$refs.inputMatrice) this.$refs.inputMatrice.reset();
    },
    hasFileMatrice(files) {
      // console.log("files", files);
      if (files.length) this.matrice = files[0];
    },
    cancelWin() {
      this.dialog = false;
    },
    async saveWin() {
      this.disabledBtn = true;
      // return alert("this.ca_id:" + this.ca_id);
      if (this.matrice) {
        let formData = new FormData();
        formData.append("ca_id", this.ca_id);
        formData.append("matrice", this.matrice);
        await this.$axios.post(
          this.$config.server_url + "/api/1.0/matrice/import",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );
      }
      this.$emit("imported", this.ca_id);
      this.dialog = false;
    },
    setContainerStyle(bis = false) {
      this.$nextTick(() => {
        if (!this.$refs.mycontainer) return;
        if (this.$refs.mycontainer.clientHeight > window.innerHeight - 300)
          this.stylecontainer = `height: calc(100vh - 253px); overflow:auto;`;
        else this.stylecontainer = "";
      });
      if (bis) {
        setTimeout(() => {
          this.setContainerStyle();
        }, 500);
      }
    }
  }
};
</script>

<style lang="scss">
.btn-norme-matrice {
  width: 100%;
}
</style>